const l = (o) => o.objType === "CalloutBox", t = (o) => l(o) && o.poiInfo.tempLabel !== void 0;
export {
  l as isCalloutBox,
  t as isRoadLabelCalloutBox
};
//# sourceMappingURL=index.es447.js.map
